// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CameraResource extends Resource {
    basePath: string = 'services/integrations/daview/cameras/';

    objectPath: string = 'services/integrations/daview/cameras/{ident}/';
}
